import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import { MtcCoreService } from '../mtc-core.service';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { IMtc } from '../mtc.interface';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-mtc-selector',
  templateUrl: './mtc-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MtcSelectorComponent),
    },
  ],
})
export class MtcSelectorComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  private _unsubscribe$ = new Subject<void>();

  @Input()
  hint = '';

  @Output() itemSelected = new EventEmitter<IMtc>();

  ctrl: FormControl = new FormControl();
  constructor(public mtcCoreService: MtcCoreService) {}

  ngOnInit(): void {
    this.ctrl.valueChanges
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((value: string) => {
        const mtc = this.mtcCoreService.getMtcInfo(value);
        this.itemSelected.emit(mtc);
        if (value) {
          this.onChange(value);
        } else {
          this.onChange(null);
        }
      });
  }

  onChange: any = (): void => {};
  onTouch: any = (): void => {};

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  writeValue(v: string): void {
    this.ctrl.setValue(v);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ctrl.disable();
    } else {
      this.ctrl.enable();
    }
  }

  refresh(): void {
    this.mtcCoreService.refresh(true);
  }
}
